import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';
import { VehicleModel }      from '../../app-lite/vehicles/models/vehicle';

export class InvoiceNewRenewalDatesCtrl{
  $q               : ng.IQService;
  $uibModalInstance: ng.ui.bootstrap.IModalInstanceService;
  Invoice          : any;
  messages         : any;
  regoLabel        : string;
  renewal_details  : any;
  sessionObjAPI    : SessionService;
  vehicle          : VehicleModel;
  workshopAPI      : ApiService;

  constructor (
    $q               : ng.IQService,
    $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
    Invoice          : any,
    messages         : any,
    sessionObjAPI    : SessionService,
    vehicle          : VehicleModel,
    workshopAPI      : ApiService
  ) {
    this.$q                = $q;
    this.$uibModalInstance = $uibModalInstance;
    this.Invoice           = Invoice;
    this.messages          = messages;
    this.sessionObjAPI     = sessionObjAPI;
    this.vehicle           = vehicle;
    this.workshopAPI       = workshopAPI;

    this.regoLabel = this.sessionObjAPI.countrySettings().rego_label;

    this.renewal_details = {
      new_plate_renewal_date: this.Invoice.invoice.new_plate_renewal_date || this.vehicle.plate_renewal_date        || '',
      new_wof_renewal_date  : this.Invoice.invoice.new_wof_renewal_date   || this.vehicle.warrant_of_fitness_date   || '',
      odometer              : this.Invoice.invoice.odometer               || this.vehicle.odometer                  || '',
      vehicle_hours         : this.Invoice.invoice.vehicle_hours          || this.vehicle.vehicle_hours             || ''
    };
  }

  save ( form : ng.IFormController ) : void {
    this.$q.when()
    .then(() => this.Invoice.save())
    .then(() => this.workshopAPI.patch('/invoice/update_vehicle_details_on_process_invoice', {
      invoice_id        : this.Invoice.invoice.id,
      odometer          : this.renewal_details.odometer,
      plate_renewal_date: this.renewal_details.new_plate_renewal_date,
      vehicle_hours     : this.renewal_details.vehicle_hours,
      wof_renewal_date  : this.renewal_details.new_wof_renewal_date
    }, 'invoice'))
    .then(( invoice : any ) => this.workshopAPI.get('/invoice', invoice.id))
    .then(( invoice : any ) => {
      this.$uibModalInstance.close(invoice);
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    });
  };
}
